"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
var React = require("react");
// @ts-ignore
var useMicrofrontend_1 = require("../../../utils/hooks/useMicrofrontend");
var config_1 = require("../../../utils/config");
var Footer = function (props) {
    var id = "eos-footer";
    var configUrl = props.eosContentUrl ? props.eosContentUrl : config_1.default.eosContentUrl;
    // @ts-ignore
    var _a = (0, useMicrofrontend_1.default)("eosContent", configUrl), isLoaded = _a.isLoaded, eosContent = _a.eosContent;
    React.useEffect(function () {
        if (!eosContent)
            return;
        var render = eosContent.render, unMount = eosContent.unMount;
        render(id);
        return function () { return unMount(id); };
    }, [isLoaded]); // eslint-disable-line
    if (!isLoaded)
        return null;
    if (!eosContent)
        return React.createElement("div", { id: "missing-footer" });
    return React.createElement("div", { id: id });
};
exports.Footer = Footer;
//# sourceMappingURL=Footer.js.map